module.exports = __webpack_public_path__ + "static/img/YN.7858f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/YN.png
// module id = Ugf4
// module chunks = 34